import enTables from './en/Tables';
import ruTables from './ru/Tables';
import enUpdates from './en/Updates';
import ruUpdates from './ru/Updates';
import enSettings from './en/Setting.Download';
import ruSettings from './ru/Setting.Download';
import enComponents from './en/Components';
import ruComponents from './ru/Components';
import enPatchNotes from './en/Patch.Notes';
import ruPatchNotes from './ru/Patch.Notes';

export default {
    en: {
        translation: {
            tables: enTables,
            updates: enUpdates,
            setting: enSettings,
            components: enComponents,
            patchNotes: enPatchNotes
        }
    },
    ru: {
        translation: {
            tables: ruTables,
            updates: ruUpdates,
            setting: ruSettings,
            components: ruComponents,
            patchNotes: ruPatchNotes
        }
    }
};
